// import React, { useEffect, useMemo, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { GLOBALTYPES } from "../redux/actions/globalTypes";
// import { getDataAPI } from "../utils/fetchData";
// import Adminnavbar from "./adminnavbar";
// import Footer from "./footer";
// import LoginRequest from "./loginRequest";
// import Sidenavbar from "./sidenav";

// // Constants for styles
// const CONTAINER_STYLE = { backgroundColor: "#ffffff", padding: "30px" };
// const DASHBOARD_ROW_STYLE = {
// 	paddingTop: "20px",
// 	paddingBottom: "20px",
// 	backgroundImage: "linear-gradient(#a7d588,#c9e6bb)",
// };

// const DASHBOARD_CARDS = [
// 	{ key: "totalusers", label: "Total Users", bgColor: "#24A2B3" },
// 	{ key: "maleusers", label: "Male Users", bgColor: "#E96CB4" },
// 	{ key: "femaleusers", label: "Female Users", bgColor: "#7F2DA2" },
// ];

// const Usermanagement = () => {
// 	const { auth } = useSelector((state) => state);
// 	const [userDetails, setUserDetails] = useState({});
// 	const [loading, setLoading] = useState(true);
// 	const [error, setError] = useState(null);

// 	const dispatch = useDispatch();

// 	useEffect(() => {
// 		const fetchUserDetails = async () => {
// 			try {
// 				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
// 				setLoading(true);
// 				setError(null);

// 				const res = await getDataAPI(`getuserscount`);
// 				setUserDetails(res.data.userdetails || {});
// 			} catch (err) {
// 				setError("Failed to load user details");
// 				console.error("Error fetching user details:", err);
// 			} finally {
// 				setLoading(false);
// 				dispatch({
// 					type: GLOBALTYPES.ALERT,
// 					payload: { loading: false },
// 				});
// 			}
// 		};

// 		fetchUserDetails();
// 	}, [dispatch]);

// 	// Memoize dashboard cards to prevent unnecessary re-renders
// 	const dashboardCards = useMemo(() => {
// 		return DASHBOARD_CARDS.map((card) => (
// 			<div
// 				key={card.key}
// 				className="col text-format"
// 				style={{ backgroundColor: card.bgColor }}>
// 				<div className="text1">{userDetails[card.key] || 0}</div>
// 				<div className="text1">{card.label}</div>
// 			</div>
// 		));
// 	}, [userDetails]);

// 	if (!auth.user) {
// 		return <LoginRequest />;
// 	}

// 	return (
// 		<>
// 			<Adminnavbar />
// 			<div style={CONTAINER_STYLE}>
// 				<div className="dashboard-text">Super Admin Dashboard</div>
// 				<div id="admin">
// 					<div>
// 						<div className="row format">
// 							<Sidenavbar />
// 							<div className="col-8">
// 								{loading ? (
// 									<div className="text-center p-4">
// 										Loading user statistics...
// 									</div>
// 								) : error ? (
// 									<div className="text-center p-4 text-danger">{error}</div>
// 								) : (
// 									<div className="row format" style={DASHBOARD_ROW_STYLE}>
// 										{dashboardCards}
// 									</div>
// 								)}
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			</div>
// 			<Footer />
// 		</>
// 	);
// };

// export default Usermanagement;

// src/pages/Usermanagement.js
import { useEffect, useMemo, useState } from "react";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import { useDispatch, useSelector } from "react-redux";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataAPI } from "../utils/fetchData";
import Adminnavbar from "./adminnavbar";
import Footer from "./footer";
import LoginRequest from "./loginRequest";
import Sidenavbar from "./sidenav";

const Usermanagement = () => {
	const { auth } = useSelector((state) => state);
	const dispatch = useDispatch();

	// ── State ───────────────────────────────────────
	const [courses, setCourses] = useState([]);
	const [grandTotal, setGrandTotal] = useState(0);
	const [grandActive, setGrandActive] = useState(0);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const [sortConfig, setSortConfig] = useState({
		key: "activeCount",
		direction: "desc",
	});

	// Modal
	const [showModal, setShowModal] = useState(false);
	const [selectedCourse, setSelectedCourse] = useState(null);
	const [userList, setUserList] = useState([]);
	const [modalLoading, setModalLoading] = useState(false);
	const [modalError, setModalError] = useState(null);

	// ── Token Helpers ───────────────────────────────
	const getToken = () => auth?.token || localStorage.getItem("authToken");

	const isValidJwt = (t) =>
		typeof t === "string" && t.includes(".") && t.split(".").length === 3;

	const logout = () => {
		localStorage.removeItem("authToken");
		dispatch({ type: GLOBALTYPES.AUTH, payload: {} });
		window.location.href = "/login";
	};

	// ── Fetch Main Stats ────────────────────────────
	useEffect(() => {
		const fetchStats = async () => {
			const token = getToken();

			if (!isValidJwt(token)) {
				setError("Please log in to access the dashboard.");
				setLoading(false);
				return;
			}

			try {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
				setLoading(true);
				setError(null);

				const res = await getDataAPI("getactivecount", token);
				const list = (res.data.courseregisters || []).map((c) => ({
					courseId: c.courseId,
					courseName: c.courseTitle,
					totalCount: c.total,
					activeCount: c.active,
					isactive: c.isactive,
				}));

				setCourses(list);
				setGrandTotal(res.data.grandtotal ?? 0);
				setGrandActive(res.data.grandActive ?? 0);
			} catch (err) {
				const msg =
					err?.response?.data?.msg || err?.message || "Failed to load data";
				setError(msg);
				if (
					msg.toLowerCase().includes("jwt") ||
					msg.toLowerCase().includes("unauthorized")
				) {
					logout();
				}
			} finally {
				setLoading(false);
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
			}
		};

		fetchStats();
	}, [auth?.token, dispatch]);

	// ── View Users for Course ───────────────────────
	const handleView = async (courseId, courseName) => {
		const token = getToken();
		if (!isValidJwt(token)) return logout();

		setSelectedCourse({ id: courseId, name: courseName });
		setUserList([]);
		setModalError(null);
		setModalLoading(true);
		setShowModal(true);

		try {
			const res = await getDataAPI(
				`getcourseregistersbycourseid/${courseId}`,
				token
			);
			const users = (res.data.courseregisters || []).sort((a, b) =>
				a.fullname.localeCompare(b.fullname)
			);
			setUserList(users);
		} catch (err) {
			const msg =
				err?.response?.data?.msg || err?.message || "Failed to load users";
			setModalError(msg);
			if (
				msg.toLowerCase().includes("jwt") ||
				msg.toLowerCase().includes("unauthorized")
			) {
				logout();
			}
		} finally {
			setModalLoading(false);
		}
	};

	// ── Sorting ─────────────────────────────────────
	const sortedCourses = useMemo(() => {
		const list = [...courses];
		if (sortConfig.key) {
			list.sort((a, b) => {
				const aVal = a[sortConfig.key];
				const bVal = b[sortConfig.key];
				if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
				if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
				return 0;
			});
		}
		return list;
	}, [courses, sortConfig]);

	const requestSort = (key) => {
		let dir = "asc";
		if (sortConfig.key === key && sortConfig.direction === "asc") dir = "desc";
		setSortConfig({ key, direction: dir });
	};

	// ── Export Main Table to CSV ─────────────────────
	const exportToCSV = () => {
		const headers = ["S.No", "Course Name", "Total", "Active"];
		const rows = sortedCourses.map((c, i) => [
			i + 1,
			c.courseName,
			c.totalCount,
			c.activeCount,
		]);

		// Add Grand Total
		rows.push(["", "Grand Total", grandTotal, grandActive]);

		const csvContent =
			"data:text/csv;charset=utf-8," +
			[headers, ...rows].map((row) => row.join(",")).join("\n");

		const encodedUri = encodeURI(csvContent);
		const link = document.createElement("a");
		link.setAttribute("href", encodedUri);
		link.setAttribute(
			"download",
			`course_enrollments_${new Date().toISOString().split("T")[0]}.csv`
		);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	// ── Export Modal Users to CSV ────────────────────
	const exportUsersToCSV = () => {
		const headers = ["S.No", "Name", "Email", "Status"];
		const rows = userList.map((u, i) => [
			i + 1,
			u.fullname,
			u.email,
			u.isactive ? "Active" : "Inactive",
		]);

		const csvContent =
			"data:text/csv;charset=utf-8," +
			[headers, ...rows].map((row) => row.join(",")).join("\n");

		const safeName =
			selectedCourse?.name.replace(/[^a-z0-9]/gi, "_") || "course";
		const encodedUri = encodeURI(csvContent);
		const link = document.createElement("a");
		link.setAttribute("href", encodedUri);
		link.setAttribute(
			"download",
			`users_${safeName}_${new Date().toISOString().split("T")[0]}.csv`
		);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	// ── Guard: Not logged in ───────────────────────
	if (!auth?.user && !getToken()) return <LoginRequest />;

	// ── Render Rows ─────────────────────────────────
	const courseRows = sortedCourses.map((c, i) => (
		<tr key={c.courseId}>
			<td>{i + 1}</td>
			<td>{c.courseName}</td>
			<td>{c.totalCount}</td>
			<td style={{ fontWeight: 600, color: "#2c7a2c" }}>{c.activeCount}</td>
			<td>
				<Button
					variant="primary"
					size="sm"
					onClick={() => handleView(c.courseId, c.courseName)}>
					View Users
				</Button>
			</td>
		</tr>
	));

	// ── JSX ─────────────────────────────────────────
	return (
		<>
			<Adminnavbar />
			<div style={{ background: "#fff", padding: "30px" }}>
				<div className="button-format">
					<div className="dashboard-text">Super Admin Dashboard</div>
				</div>

				<div className="row format">
					<Sidenavbar />
					<div className="col-8">
						{/* Stats Cards */}

						{/* Main Table + Export Button */}
						<div className="mt-4">
							<div className="d-flex justify-content-between align-items-center mb-3">
								<h4 style={{ margin: 0, fontWeight: 600 }}>
									Course Enrollment Statistics
								</h4>
								<Button variant="success" size="sm" onClick={exportToCSV}>
									Export to CSV
								</Button>
							</div>

							{loading ? (
								<div className="text-center p-5">
									<div className="spinner-border text-primary" role="status">
										<span className="visually-hidden">Loading…</span>
									</div>
								</div>
							) : error ? (
								<div className="alert alert-danger text-center">{error}</div>
							) : (
								<Table bordered hover responsive className="table-sm">
									<thead className="table-light">
										<tr>
											<th>S.No</th>
											<th
												style={{ cursor: "pointer" }}
												onClick={() => requestSort("courseName")}>
												Course Name
											</th>
											<th
												style={{ cursor: "pointer" }}
												onClick={() => requestSort("totalCount")}>
												Total
											</th>
											<th
												style={{ cursor: "pointer" }}
												onClick={() => requestSort("activeCount")}>
												Active
											</th>
											<th>Actions</th>
										</tr>
									</thead>
									<tbody>
										{courseRows}
										<tr style={{ fontWeight: "bold", background: "#f8f9fa" }}>
											<td
												colSpan={2}
												style={{ textAlign: "right", paddingRight: "20px" }}>
												Grand Total
											</td>
											<td style={{ fontWeight: "bold" }}>{grandTotal}</td>
											<td style={{ fontWeight: "bold", color: "#2c7a2c" }}>
												{grandActive}
											</td>
											<td></td>
										</tr>
									</tbody>
								</Table>
							)}
						</div>
					</div>
				</div>
			</div>

			{/* Users Modal – WITH STATUS + EXPORT */}
			<Modal
				show={showModal}
				onHide={() => setShowModal(false)}
				size="lg"
				centered>
				<Modal.Header closeButton>
					<Modal.Title>
						Registered Users – <strong>{selectedCourse?.name}</strong>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{modalLoading ? (
						<div className="text-center p-4">
							<div className="spinner-border text-primary" role="status">
								<span className="visually-hidden">Loading…</span>
							</div>
						</div>
					) : modalError ? (
						<div className="alert alert-danger">{modalError}</div>
					) : userList.length === 0 ? (
						<div className="text-center text-muted">No users enrolled.</div>
					) : (
						<>
							<div className="d-flex justify-content-end mb-2">
								<Button variant="success" size="sm" onClick={exportUsersToCSV}>
									Export Users to CSV
								</Button>
							</div>
							<div style={{ maxHeight: "450px", overflowY: "auto" }}>
								<Table striped bordered hover size="sm">
									<thead className="table-secondary">
										<tr>
											<th>S.No</th>
											<th>Name</th>
											<th>Email</th>
											<th>Status</th>
										</tr>
									</thead>
									<tbody>
										{userList.map((u, i) => (
											<tr key={u.id}>
												<td>{i + 1}</td>
												<td>{u.fullname}</td>
												<td>{u.email}</td>
												<td>
													<Badge bg={u.isactive ? "success" : "danger"} pill>
														{u.isactive ? "Active" : "Inactive"}
													</Badge>
												</td>
											</tr>
										))}
									</tbody>
								</Table>
							</div>
						</>
					)}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={() => setShowModal(false)}>
						Close
					</Button>
				</Modal.Footer>
			</Modal>

			<Footer />
		</>
	);
};

export default Usermanagement;
